"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogInfo = exports.LogWarn = exports.LogError = void 0;
var LogType;
(function (LogType) {
    LogType[LogType["INFO"] = 0] = "INFO";
    LogType[LogType["WARN"] = 1] = "WARN";
    LogType[LogType["ERROR"] = 2] = "ERROR";
})(LogType || (LogType = {}));
function Log(logType, message) {
    let prefix = "";
    let color = "";
    const resetColor = "\x1b[0m";
    if (logType === LogType.WARN) {
        prefix = "WARN";
        color = "\x1b[33m";
    }
    else if (logType === LogType.ERROR) {
        prefix = "ERROR";
        color = "\x1b[31m";
    }
    const message_ = `${color}[${new Date().toISOString()}] ${prefix} ${message} ${resetColor}`;
    switch (logType) {
        case LogType.INFO:
            console.log(message_);
            break;
        case LogType.WARN:
            console.warn(message_);
            break;
        case LogType.ERROR:
            console.error(message_);
            break;
    }
}
function LogError(error) {
    var _a;
    const message = error instanceof Error ? (_a = error.message + error.stack) !== null && _a !== void 0 ? _a : "" : error.toString();
    Log(LogType.ERROR, message);
}
exports.LogError = LogError;
function LogWarn(message) {
    Log(LogType.WARN, message);
}
exports.LogWarn = LogWarn;
function LogInfo(message) {
    Log(LogType.INFO, message);
}
exports.LogInfo = LogInfo;
